import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { useOutletContext } from "react-router";
import Loader from "components/Common/loader";
import CustomAlert from "components/Common/ui/CustomAlert";
import CustomButton from "components/Common/ui/CustomButton";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import useAuthorizedPickUpPerson from "feature-module/administration/authorized-pickup-persons/hooks/useAuthorizedPickUpPerson";
import AuthorizedPickUpPersonTable from "feature-module/administration/authorized-pickup-persons/components/AuthorizedPickUpPersonTable";
import AddEditAuthorizedPickUpPerson from "feature-module/administration/authorized-pickup-persons/components/AddEditAuthorizedPickUpPerson";

type Ctx = { student: any | null };

const StudentAuthorizedPickUpPersonTab: React.FC = () => {
    console.log("im stille here now")
    const { t } = useTranslation();
    const { student } = useOutletContext<Ctx>();
    const studentId = useMemo(() => student?.id, [student]);

    const {
        authorizedPickUpPersons,
        loading,
        infoPagination,
        relationshipOptions,
        fetchByStudentId,
    } = useAuthorizedPickUpPerson();

    const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

    const filterFields: FilterField[] = useMemo(
        () => [
            { key: "search", label: t("search"), type: "text" },
            { key: "relationship", label: t("authorizedPickUpPerson.form.relationship"), type: "select", options: relationshipOptions },
        ],
        [t, relationshipOptions]
    );



    const handleFilter = (newFilters: { [key: string]: any }) => {
        setFilters(newFilters);
        refetchData(newFilters);
    };

    const refetchData = (currentFilters = filters) => {
        const params = {
            ...currentFilters,
            page: 1,
            limit: 10,
        };

        if (studentId) {
            fetchByStudentId(studentId, params);
        }
    };




    // Refresh authorized pick-up persons when studentId changes
    useEffect(() => {
        if (studentId) {
            fetchByStudentId(studentId, { page: 1, limit: 10 });
        }
    }, [studentId]);

    if (loading) return <Loader />;

    return (
        <div className="p-2">
            {!studentId ? (
                <CustomAlert
                    message={t("alert.no_student_selected.message")}
                    description={t("alert.no_student_selected.description")}
                    type="warning"
                    showIcon
                />
            ) : (
                <>
                    <div className="mb-3 d-flex justify-content-end">
                        <div className="d-flex gap-2">
                            <TableFilterDynamique
                                fields={filterFields}
                                filters={filters}
                                onApply={handleFilter}
                                onReset={() => handleFilter({ page: 1, limit: 10 })}
                            />
                        </div>
                    </div>

                    <AuthorizedPickUpPersonTable
                        dataSource={authorizedPickUpPersons}
                        loading={loading}

                        dataPaginate={{
                            current: infoPagination?.page,
                            pageSize: infoPagination?.limit,
                            total: infoPagination?.total,
                        }}
                        onChange={(pg) => {
                            const params = {
                                ...filters,
                                page: pg.current!,
                                limit: pg.pageSize!,
                            };
                            fetchByStudentId(studentId, params);
                        }}
                    />


                </>
            )}
        </div>
    );
};

export default StudentAuthorizedPickUpPersonTab;